import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../redux/hooks";
import { hideMenu, menuState, showMenu } from "../redux/slice/MenuSlice";
import MenuLayout from "./MenuLayout";
import { Container } from 'react-bootstrap';

const HeaderLayout = () => {

    const menu = useAppSelector(menuState);
    const dispatch = useAppDispatch();
    
    const [ profileMenu, setProfileMenu ] = useState(false);

    const profileMenuToggle = () => {
        setProfileMenu(!profileMenu);
    }

    return (
        <Container fluid>
            <header className="header">
                <div className="row">
                    <div className="col-lg-5 col-md-5 col-6">
                        <div className="header-left d-flex align-items-center">
                            <div className="menu-toggle-btn mr-20" onClick={() => {
                                if(menu.active) {
                                    dispatch(showMenu());
                                } else {
                                    dispatch(hideMenu());
                                }
                            }}>
                                <button id="menu-toggle" className="main-btn btn-hover">
                                    <i className="lni lni-chevron-left me-2"></i>Menu
                                </button>
                            </div>
                            {/* <div className="header-search d-none d-md-flex">
                                <form action="#">
                                    <input type="text" placeholder="Search..." />
                                    <button><i className="lni lni-search-alt"><jsp:text /></i></button>
                                </form>
                            </div> */}
                        </div>
                    </div>
                    <div className="col-lg-7 col-md-7 col-6">
                        <div className="header-right">
                            <div className="profile-box ml-15">
                                <button className="dropdown-toggle bg-transparent border-0" type="button" id="profile" data-bs-toggle="dropdown" aria-expanded="false">
                                    <div className="profile-info">
                                        <div className="info">
                                            <h6>User</h6>
                                            <div className="image" onClick={() => profileMenuToggle()}>
                                                <img src="/images/rain-opacity.png" alt="" />
                                            </div>
                                        </div>
                                    </div>
                                    <i className="lni lni-chevron-down"></i>
                                </button>
                                <ul className="dropdown-menu dropdown-menu-end" aria-labelledby="profile"
                                    style={
                                        profileMenu 
                                        ? { display: 'block' }
                                        : {}
                                    }
                                >
                                    <li>
                                        <a href="#0">
                                            <i className="lni lni-user"></i>View Profile
                                        </a>
                                    </li>
                                    <li>
                                        <a href="/logout"> <i className="lni lni-exit"></i>Logout</a>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </header>   
        </Container>
    )
}

export default HeaderLayout;
